const rootPath = '/img/png/external-app-logos';

const externalAppLogos = {
  x: `${rootPath}/x.png`,
  youtube: `${rootPath}/youtube.png`,
  tiktok: `${rootPath}/tiktok.png`,
  instagram: `${rootPath}/instagram.png`,
  facebook: `${rootPath}/facebook.png`,
  linkedin: `${rootPath}/linkedin.png`,
  quora: `${rootPath}/quora.png`,
};

export default externalAppLogos;
